import { Component, Input } from "@angular/core";

@Component({
  selector: "app-loading-three-point",
  styleUrls: ["./loading-three-point.component.scss"],
  templateUrl: "./loading-three-point.component.html",
})
export class LoadingThreePointComponent {
  @Input() pointWhite: boolean;
}
